import type { AppRouteRecordRaw } from '@/router/types'
import { mapRepastPath } from '@/utils/repastRedirect'

/**
 * 旧 /ai-Application-center/catering/repast/* → 新统一管理路径
 */
const cateringEmbeddedRoutes: AppRouteRecordRaw[] = [
  {
    path: '/ai-Application-center/catering/repast/:pathMatch(.*)*',
    redirect: (to) => {
      const raw = to.params.pathMatch
      const rest = Array.isArray(raw) ? raw.join('/') : String(raw || '')
      return {
        path: mapRepastPath(rest ? `/repast/${rest}` : '/repast/home'),
        query: to.query,
        hash: to.hash
      }
    },
    meta: { hidden: true }
  },
  {
    path: '/ai-Application-center/catering/repast',
    redirect: () => mapRepastPath('/repast/home'),
    meta: { hidden: true }
  }
]

export default cateringEmbeddedRoutes
